// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./vively/styles/main.scss
// module id = 856
// module chunks = 3